/**
 * @ignore
 * Created by Shanie on 12/1/16.
 */
import { cutoffs, deviceTypes, privacySettings, sortBy, viewModes } from './constants';

const getInitialState = ({
    deviceType = deviceTypes.DESKTOP,
    isDiscoverPageEnabled = false,
    newPortfolioPrivacy = privacySettings.PUBLIC,
    portfolioDoesNotExist = true,
    portfolioIds,
    portfolioName = '',
    portfolioTypes,
    portfolioViewPermission = true,
    projectId = '',
    tab = 'discover',
    isPublic = false,
    searchTerm = '',
    page = 1,
    itemsSort = sortBy.CUSTOM,
}) => {
    return {
        favorites: {
            creationState: {
                newPortfolioDescription: '',
                newPortfolioName: '',
                newPortfolioPrivacy,
                note: '',
                noteImage: '',
                noteTitle: '',
            },
            editInlineState: {
                editInline: false,
                editFolder: false,
            },
            emailState: {
                personalizedMessage: '',
                recipientEmails: [],
                senderEmail: '',
                senderName: '',
                showNotes: false,
            },
            modalState: {
                modalOpen: false,
                openModalType: '',
                showErrorSuccessModal: false,
            },
            uiState: {
                createFolderOnLoad: false,
                readyToRender: true,
                currency: 'USD',
                deviceType,
                editing: false,
                favoriteItemOnLoad: false,
                first: cutoffs.ADDITIONAL_ITEMS,
                folderSort: sortBy.CUSTOM,
                foldersSort: sortBy.CUSTOM,
                followingSort: sortBy.CUSTOM,
                isDiscoverPageEnabled,
                isLoadingFullPage: false,
                isLoadingPartialPage: false,
                itemsSort,
                mutationResponse: '',
                navBorder: { width: 0, x: 0 },
                portfolioDoesNotExist,
                portfolioIds,
                portfolioName,
                portfolioTypes,
                portfolioViewPermission,
                projectId,
                projectSort: sortBy.CUSTOM,
                projectsSort: sortBy.CUSTOM,
                reordered: false,
                reordering: false,
                routerNavigation: false,
                selectAllStatus: '',
                selectedItems: [],
                selectedPortfolios: [],
                searchTerm,
                selecting: false,
                showNotes: false,
                sortBySelection: itemsSort,
                stickToolbar: false,
                tab,
                tabChanged: false,
                totalResults: -1,
                shouldTrackReordering: true,
                userHasChanged: false,
                isPublic,
                viewMode: viewModes.GRID,
                page,
            },
        },
    };
};

export default getInitialState;
